<template>
  <div id="content" class="candidate_pool">
        <ConfirmModal :dialogVisible='showConfirmDialog' @close="closeConfirmDialog()" @confirmed="validateSelection($event)" message="After submission, your selection will not be editable." ></ConfirmModal>
    <AddCommentModal :candidate="candidateForComments" :dialogVisible='dialog' @close="closeModal()" @newValueIsProposed="setNewValueComment($event)" formName="Add a comment" ></AddCommentModal>

       <!-- <Toaster  position="top-right" :expand="true" richColors closeButton/> -->
    <div class="container">


      <div class="candidate_pool"  v-if="assessment.candidates">
        <div class="col-12 text-center">
          <span class="pool_title">My selected candidates</span>
        </div>
        <div class="row mt50">
            <div class="col-12 col-lg-6 col-xl-4 candidate" v-for="(candidate, c) in assessment.candidates" :key="c">
              <div class="candidate_card" v-if="candidate.startup">

                <!-- <img :src="this.apiUrl+'/get_image/'+candidate.startup.image.$oid+'?token='+$store.state.innotoken" alt="" class="candidate_image"> -->
                  <!-- <router-link :to="'/startup_report/'+this.$route.params.searchfield+'/'+candidate.startup._id.$oid+'/'+assessment.project.$oid">
                    <img :src="this.apiUrl+'/get_image/'+candidate.startup.image.$oid+'?token='+$store.state.innotoken" v-if="candidate.startup.image" alt="" class="candidate_image">
                    <img src="https://www.innopearl.ch/wp-content/uploads/2022/12/inn_header-accelerator.jpg" class="candidate_image" alt="" v-else>
                    </router-link> -->
                    <div class="candidate_card_head">
                      <span class="name">{{candidate.startup.name}}</span>
                      <div class="goRight">
                        <div v-if="candidate.isAssess">
                          <div class="extraPoolsContainer">
                            <img :src="require('@/assets/isAssess.svg')" class="extraPoolsIcons">
                            <span class="hoverInfo">In assessment stage</span>
                          </div>
                        </div>


                      </div>

                    </div>
                     <div class="candidate_info_content">


                        <StartupInfoLine v-if="candidate.startup.value_proposition" name="Value proposition" class="noBorder" :value="candidate.startup.value_proposition" />
                        <StartupInfoLine v-else name="Value proposition" value="No data" class="noBorder"/>

                        <StartupInfoLine v-if="candidate.startup.solution" name="Solution" class="noBorder" :value="candidate.startup.solution" />
                        <StartupInfoLine v-else name="Solution" value="No data" class="noBorder"/>




                    </div>
              <!-- <div class="candidate_info_content">
                  <router-link :to="'/startup_report/'+this.$route.params.searchfield+'/'+candidate.startup._id.$oid+'/'+assessment.project.$oid">
                    <span class="candidate_name">{{candidate.startup.name}}</span>
                  </router-link>
                <span class="candidate_desc">{{candidate.startup.value_proposition}}</span>
              </div> -->
              <div class="candidate_info_content candidate_links">
                <div class="details">
                    <router-link :to="'/startup_report/'+this.$route.params.searchfield+'/'+candidate.startup._id.$oid+'/'+assessment.project.$oid"><img :src="require('@/assets/eye.svg')" alt="" class="left">
                      Key insights
                    </router-link>
                </div>
                <div class="selectIt">
                  <label><span>Compare </span><input type="checkbox" v-model="candidate.compare" :disabled="selectedCandidates.length == 2 && !candidate.compare "></label>
                </div>
              </div>
              <div class=" candidate_info_content candidate_links" v-if="candidate.isSubmit">
                <div class="details">
                    Interest : {{candidate.collab_interest_level}}
                </div>
              </div>
              <div class=" candidate_info_content candidate_links" v-if="candidate.isSubmit">
                <div class="details">
                  Selected for introduction : {{ (candidate.select_for_introduction == true) ? 'yes' : "no" }}
                </div>
              </div>
              <div class="candidate_links candidate_comments" style="">
                <!-- <div  v-if="candidate.comments">


                <small>Comment<span v-if="candidate.comments.length > 1">s</span></small>
                 <div class="comments_list"  v-if="candidate.comments">
                    <div class="one_comment" v-for="(comment, i) in candidate.comments" :key="i">
                      <span v-if="comment.value"> <strong v-if="comment.by">{{comment.by}} : </strong><span v-html="comment.value"></span></span>
                          <span v-else>{{comment}}</span>
                    </div>

                </div>
                    </div>
                <div class="add_comment col-12 text-right">
                    <button type="button" class="add_new_comment" @click='openModal(candidate)' name="button">
                      <img :src="require('@/assets/comments.svg')" alt="">
                      Add a comment</button>
                </div> -->

                <div class="showComments" @click='openModal(candidate)' >
                  <img :src="require('@/assets/comments.svg')" alt="">
                  <span class="nb_item_comments" v-if="candidate.comments">{{candidate.comments.length}}</span>
                  <span class="nb_item_comments" v-else>0</span>

                </div>
              </div>
                    </div>

            </div>
        </div>

        <div class="col-12 text-center mt50" >

            <router-link v-if="selectedCandidates.length == 2" type="button" name="button" class="next_step_btn" :to="'/compare_startup/'+this.$route.params.searchfield+'/'+selectedCandidates[0].startup_id.$oid+'/'+selectedCandidates[1].startup_id.$oid+'/'+assessment.project.$oid">
              COMPARE
              <img :src="require('@/assets/next.svg')" alt="">
            </router-link>
        </div>
        <div class="row">

          <div class="alert alert-info y" v-if='assessment.isSubmit == true'>
              Your selection of potential partners for this business challenge is now completed.
          </div>
        <div class="col-12 col-md-6 mt50"  v-if="assessment.project">
        <router-link type="button" name="button" class="prev_step_btn text-left " :to="'/projet/'+assessment.project.$oid">
              <img :src="require('@/assets/prev.svg')" alt="">
              Back to project dashboard

         </router-link>
       </div>
         <div class="col-12 col-md-6 mt50 text-right"  v-if="assessment.project">
                     <button type="button" name="button" class="next_step_btn" @click='showConfirmDialog = true' v-if='assessment.isSubmit != true'>
                       Validate your selection
                       <img :src="require('@/assets/next.svg')" alt="">
                     </button>
        </div>      </div>

        </div>
        <div class="candidate_pool"  v-else>
          <div class="col-12 text-center">
              <span class="pool_title">Assessment space</span>
          <div class="alert alert-warning mt50">
            This assessment will be provided once you have selected your preferred candidates.
          </div>
          </div>
      </div>

    </div>
  </div>
</template>
<script>
//import { Toaster, toast } from 'vue-sonner'
import api from '../tools/api';
import { toast } from 'vue-sonner'
 import AddCommentModal from '@/components/modals/addCommentWithList.vue'
import ConfirmModal from '@/components/modals/ConfirmModal.vue';
import StartupInfoLine from '@/components/InfoStartupLine.vue'
export default {
  components: {
    AddCommentModal,
    ConfirmModal,
    StartupInfoLine
     // Toaster
  },
  name: 'AssessmentSpace',
  data() {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      pageInfo: {
        mainTitle : "Assessment space",
        subTitle : "Validate your assessed partners",
      },
      candidateForComments:"",
      dialog:false,
      showConfirmDialog:false,
      assessment: {
        candidates : [
          // {
          //   id:"6492de3ab9dc92db3b3129bb",
          //   startup_id : "1",
          //   img: "https://www.innopearl.ch/wp-content/uploads/2022/12/inn_header-accelerator.jpg",
          //   name:"Choix 1.1",
          //   short_desc: "Sed ut accumsan enim Vitae dolor malesuada, elementum",
          //   selected: false,
          //   compare : false,
          //   interest: 'medium',
          //   introduction: true,
          //   isSubmit: false,
          // },
          // {
          //   id:"6492de3ab9dc92db3b3129bb",
          //   startup_id : "1.2",
          //   img: "https://www.innopearl.ch/wp-content/uploads/2022/12/inn_header-corporate.jpg",
          //   name:"Choix 1.2",
          //   short_desc: "Sed ut accumsan enim Vitae dolor malesuada, elementum. Sed ut accumsan enim Vitae dolor malesuada, elementum",
          //   selected: true,
          //   compare : false,
          //   interest: 'medium',
          //   introduction: true,
          //   isSubmit: false,
          // },
          // {
          //   id:"6492de3ab9dc92db3b3129bb",
          //   startup_id : "1.3",
          //   img: "https://www.innopearl.ch/wp-content/uploads/2022/12/inn_header-startup.jpg",
          //   name:"Choix 1.3",
          //   short_desc: "Sed ut accumsan enim Vitae dolor malesuada, elementum",
          //   selected: false,
          //     compare : false,
          //     interest: 'medium',
          //     introduction: true,
          //     isSubmit: false,
          // },
        ],
        isSubmit : false,
      }

    }
  },
  methods:{

    closeModal(){
      this.candidateForComments = "";
      this.dialog = false;
    },
    openModal(candidate){
      this.candidateForComments = candidate;
      this.dialog = true;
    },
    closeConfirmDialog(){
      this.showConfirmDialog = false;
    },
    validateSelection(){
      this.showConfirmDialog = false;
      api.post(process.env.VUE_APP_API_URL+"/restrict/search_field/close_assessment/"+this.$route.params.searchfield,
      {},
      {
        headers: {
            'Content-Type': 'application/json',
      }
    }).then( (r) => {
      console.log(r);
      toast.success("Your selection of potential partners for this business challenge is now completed");
      this.assessment.isSubmit = true;

    }).catch( () => {
        toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
    });
    },
    setNewValueComment(v){
      if(v){
        api.post(process.env.VUE_APP_API_URL+"/restrict/search_field/assessment/candidate/add_comment",
        {
          comment : v,
          candidate : this.candidateForComments,
          sf:this.$route.params.searchfield,
        },
        {
          headers: {
              'Content-Type': 'application/json',
        }
      }).then( (r) => {
        console.log(r);
        toast.success("Your comment is added");
        console.log(this.candidateForComments.comments);
        if(this.candidateForComments.comments === undefined)this.candidateForComments.comments =[];
          this.candidateForComments.comments.push(r.data);
          this.candidateForComments = null;
      }).catch( () => {
          this.candidateForComments = null;
          toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
      });

      }

      this.dialog = false;
    },

  },
  mounted(){
     this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo)

          api.get(process.env.VUE_APP_API_URL+"/search_field/assessmentchallenge/"+this.$route.params.searchfield).then( (r) => {
            // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
            // console.log();
            // var temp = _.merge(this.candidatespool, r.data)
            console.log("ffsf",r.data);
            this.assessment = r.data;
            console.log(this.assessment);

            if(this.assessment.isNew){
              //unset new
              api.post(process.env.VUE_APP_API_URL+"/restrict/assessment_unnew",{searchfield : this.$route.params.searchfield},{
                  headers: {
                      'Content-Type': 'application/json',
                  }
              })
              .then( () => {})
              .catch( () => {});
            }
          }).catch( (e) => {
            console.log(e);
             toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });
  },
  computed:{
    selectedCandidates: function(){
      var selectedCandidatesTemp = [];
      if(this.assessment.candidates)
      this.assessment.candidates.forEach((c) => {
              if(c.compare == true)selectedCandidatesTemp.push(c);
      });
      console.log(selectedCandidatesTemp);
      return selectedCandidatesTemp;
    },
  }

}
</script>
<style scoped>
.candidate_pool{
  padding-top:50px;
  padding-bottom:50px;
}
.all_candidates_download_zone{
    padding: 50px;
    background: #FFF;
    background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
}


.title{
  font-size: 24px;
  line-height:29px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
}
.all_candidates_download_zone .description{
  display:block;
  margin-top:10px;
  margin-bottom: 20px;
  width:100%;
}

  .next_step_btn{
    background: #3783C5 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border: 1px solid #3783C5;
    border-radius: 50px;
    opacity: 1;
    padding: 14px 37px;
    color:#FFF;
    margin:5px;
  }
  .next_step_btn img.left{
    margin-right:10px;
  }
img.goFullWhite{
  filter: brightness(0) invert(1);
}
.candidate_pool{
    padding: 50px;
    background: #FFF;
    background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
}

.pool_title{
  font-size: 24px;
  line-height:29px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
}
.pool_subtitle{
  font-size: 24px;
  line-height:29px;
letter-spacing: 0px;
color: #3783C5;
display:block;
}
.candidate{
  margin-top:20px;
  margin-bottom: 20px;
}
.candidate_card{
  border: 1px solid #DDDDDD;
border-radius: 10px;
z-index: 5;
height:100%;
}
.candidate_card .candidate_image{
  width:100%;
  height:200px;
  object-fit: cover;
  z-index: 1;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.candidate_card .candidate_info_content{
  padding:10px;
  border-bottom: 1px solid #DDDDDD;
}

.candidate_card .candidate_links{
  padding:20px;
  display:flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.candidate_card .candidate_info_content .candidate_name{
  font-size:18px;
  line-height:21px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
font-weight: 500;
}

.candidate_card .candidate_info_content .candidate_desc{
  font-size:16px;
  line-height:22px;
  margin-top:10px;
  display:block;
  margin-bottom:10px;
}
.candidate_card .candidate_links .details{
  font-size:12px;
  line-height: 15px;
  border-right: 1px solid #DDD;
  display:flex;
  align-items: center;
  text-transform: uppercase;
  color: #3783C5;
  flex: 1;

}
.candidate_card .candidate_links .details a{
    text-decoration: none;
}
.candidate_card .candidate_links .details img{
  margin-right:5px;
}
.candidate_card .candidate_links .selectIt{
  font-size:12px;
  line-height: 15px;
  letter-spacing: 0px;
  color: #3783C5;
  text-transform: uppercase;
  flex:1;
  align-items: flex-end;

}
.candidate_card .candidate_links .selectIt label{
display:flex;
align-items: center;
gap: 5px;
justify-content: end;
}
.candidate_card .candidate_links .selectIt input{
  width:24px;
  height:24px;
}
@media screen and (max-width: 690px){
  .candidate_card .candidate_links{
    flex-direction: column;
    flex-wrap: wrap;
    gap: 20px
  }
  .candidate_pool{
      padding: 20px;
    }
    .candidate_card .candidate_links .details{
      border-right: none;
      border-bottom:1px solid #DDD;
      padding-bottom: 20px;
    }
}
.mt50{
  margin-top: 50px;
}

.selection{
  margin-top:50px;
  border-top:1px solid #DDD;
  padding-top: 50px;

}
.selection .selectedOne{
  font-size: 14px;
  line-height: 17px;
  text-transform: uppercase;
  width: calc(33% - 20px);
}
.selection .selectedOne img{
    width: 65px;
    height:65px;
    border-radius: 6px;
    object-fit: cover;
    margin-right: 10px;
}

.selection .candidateSelection{
  display:flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-top:50px;
}

@media screen and (max-width: 1200px){
  .selection .selectedOne{
    font-size: 14px;
    line-height: 17px;
    text-transform: uppercase;
    width: calc(50% - 20px);
  }
}
@media screen and (max-width: 990px){
  .selection .selectedOne{
    font-size: 14px;
    line-height: 17px;
    text-transform: uppercase;
    width: calc(100%);
  }
  .selection .candidateSelection{
    flex-direction: column;
  }
}

.onePool:not(:first-of-type){
  margin-top:50px;
}

.askNewPool button{
  font-size:12px;
  line-height: 15px;
}
.prev_step_btn{
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#3783C5;
    margin:5px;
}
.prev_step_btn img{
  margin-right:10px;
}
a{
  color:inherit;
  text-decoration: none;
}



.candidate_comments{
  padding: 20px 50px;
  border-top: 1px solid #DDD;
  margin-top:auto;
}
.candidate_comments .one_comment{
  margin-top:10px;
  margin-bottom: 10px;
  font-size:12px;
  line-height:15px;
    position:relative;
}
.candidate_comments .one_comment:after {
  content: ""; /* This is necessary for the pseudo element to work. */
     display: block; /* This will put the pseudo element on its own line. */
     margin: 0 ; /* This will center the border. */
     width: 20%; /* Change this to whatever width you want. */
     padding-top: 10px; /* This creates some space between the element and the border. */

     border-bottom: 1px solid #CCC; /* This creates the border. Replace black with whatever color you want. */
}
.candidate_comments small{
  font-size:12px;
}

.add_new_comment{
  font-size:12px;
  line-height:15px;
  color: #3785C5;
  text-transform: uppercase;
  margin-top:20px;
}
.add_new_comment img{
  width: 20px;
  margin-right: 10px;
}

.showComments{
  cursor:pointer;
  position:relative;
}

.nb_item_comments{
  background: #B38D2F;
  color: #FFF !important;
  padding: 0px 6px;
  font-size: 12px;
  font-weight: bold;
  border-radius: 5px;
  position: absolute;
  top: -4px;
  right: -10px;
}
.showComments img{
  width:30px;
}
.candidate_card_head{
  background: transparent linear-gradient(270deg, #3783C5 0%, #1368B2 100%) 0% 0% no-repeat padding-box;

  padding: 10px;
  color: #FFF;
  text-transform: uppercase;
  font-weight: bold;
  border-radius: 10px 10px 0px 0px;
  display:flex;
  align-content: center;
    align-items: center;
gap:10px;
min-height: 60px;
}

</style>
